"use client";
import Link from "next/link";
import { Img } from "@/components/global/elements/Img";

export function Logo({ logo }) {
  if (!logo?.permalink) {
    return null;
  }

  // Inline max-width/width so the logo can't paint at full asset size
  // before Tailwind loads (was a CLS culprit: 751×568 → 220px wide).
  return (
    <Link
      href="/"
      className="block max-w-[220px] 2xl:max-w-[260px]"
      style={{ display: "block", width: "100%", maxWidth: 220 }}
    >
      <Img
        id="main-logo"
        data={logo}
        className="w-full h-auto"
        style={{ width: "100%", height: "auto" }}
        priority
      />
    </Link>
  );
}
